import LogInIcon from '@mui/icons-material/Login';
import LogOutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import { List, ListItemButton } from "@mui/material";
import { useCallback, useContext, useMemo, useState } from "react";
import { useNavigate } from 'react-router';
import { logout } from "../api/auth";
import MowLogoInline from "../assets/mow-full-logo-inline.svg";
import MowLogo from "../assets/mow-logo-icon.svg";
import { AccountContext } from "../context/account";
import { removeItem } from "../core/storage";
import useIsSuperAdmin from "../hooks/useIsSuperAdmin";
import useLoggedIn from "../hooks/useLoggedIn";
import useWindow from "../hooks/useWindow";
import { Img } from "./image";
import { Title } from "./navigation-content";
import { SuperAdminSettingsModal } from './super-admin-settings-modal';
import { UserSettingsModal } from "./user-settings-modal";

interface UserNavItemProps {
  open: boolean
}

export const UserNavItem = ({
  open
}: UserNavItemProps) => {
  const [openUserModal, setOpenUserModal] = useState(false)
  const [openSuperAdminModal, setOpenSuperAdminModal] = useState(false)
  const _window = useWindow();
  const { 
    setAccount, 
    companyPurchaseRequests,
    setShowLoginModal,
  } = useContext(AccountContext);

  const isLoggedIn = useLoggedIn();
  const isSuperAdmin = useIsSuperAdmin();
  const showLoginPanel = !isLoggedIn;
  const navigate = useNavigate();

  const onLogout = useCallback(() => {    
    logout();
    setAccount({ loggedIn: false, checked: true });
    removeItem('map-location')
    setShowLoginModal(false);
    navigate('/dashboard');
    _window.setTimeout(() => {
      _window.location.reload();
    }, 100)
  }, [_window.location, setAccount]);

  const onEditSettings = useCallback(() => {
    setOpenUserModal(true)
  }, [])

  const onEditSuperAdminSettings = useCallback(() => {
    setOpenSuperAdminModal(true)
  }, [])
  
  const activeRequests = useMemo(() => {
    return companyPurchaseRequests?.filter(({status}) => status === 'pending' || status === 'processing') 
  }, [companyPurchaseRequests])


  const hasRequests = useMemo(() => {
    return !!(activeRequests && activeRequests.length > 0)
  }, [activeRequests])

  return (
    <>
      <List component="nav">
        {isSuperAdmin && 
          <ListItemButton onClick={onEditSuperAdminSettings}>
            <Title
              open={open}
              title={"Super admin settings"}
              icon={<SupervisorAccountIcon />}
            />
          </ListItemButton>
        }
        {!showLoginPanel && <ListItemButton id="user-setting-nav-button" onClick={onEditSettings}>
          <Title
            open={open}
            title={"User settings"}
            icon={<SettingsIcon />}
            color={"error"}
            badgeContent={(hasRequests && activeRequests) ? activeRequests.length : ''}
            visible={hasRequests}
          />
        </ListItemButton>}
        {!showLoginPanel && 
          <ListItemButton onClick={onLogout}>
            <Title
              open={open}
              title={"Log out"}
              icon={<LogOutIcon />}
              visible={false}
            />
          </ListItemButton>
        }
        {showLoginPanel && 
          <ListItemButton onClick={() => {
            if (isLoggedIn === false) {
              setShowLoginModal(true);
            }
          }}>
            <Title
              open={open}
              title={"Log in"}
              icon={<LogInIcon />}
              visible={false}
            />
          </ListItemButton>
        }
        <ListItemButton onClick={() => {
            navigate('https://www.metoceanworks.com/')
          }}>
            <Title
              open={open}
              tooltip={"MetoceanWorks website"}
              title={<Img src={MowLogoInline} style={{transform: 'translateY(6px)'}} alt='logo inline' height={21} />}
              icon={<span style={{marginRight: '16px'}}><Img style={{transform: 'translateY(4px)'}} src={MowLogo} alt='logo' width={24} height={24} /></span>}
              visible={false}
            />
          </ListItemButton>
      </List>

      <UserSettingsModal 
        open={openUserModal} 
        handleClose={() => {
          setOpenUserModal(false)
        }} 
      />

      <SuperAdminSettingsModal 
        open={openSuperAdminModal} 
        handleClose={() => {
          setOpenSuperAdminModal(false)
        }}
      />

    </>
  )
}

